import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

@Component
class AutocompleteComponent extends Vue {

  dtSearch: string;
  dtIsLoading: boolean;
  dtOptions: any[];

  @Prop({ default: () => [], type: [Array] })
  items: any;

  @Prop({ type: [Array, Object, Number, String] })
  value: any[] | number | string;
  @Prop({ default: 300, type: [Number] })
  debounce: number;
  @Prop({ default: 'id', type: [String] })
  itemValue: string;
  @Prop({ default: 'text', type: [String] })
  itemText: string;
  @Prop({ default: false, type: [Boolean] })
  returnObject: boolean;
  @Prop({ type: [Object, Array] })
  rules: any;
  @Prop({ default: false, type: [Boolean] })
  multiple: boolean;
  @Prop({ default: false, type: [Boolean] })
  hideSelected: boolean;
  @Prop({ default: false, type: [Boolean] })
  hideNoData: boolean;
  @Prop({ default: false, type: [Boolean] })
  hideDetails: boolean;
  @Prop({ default: true, type: [Boolean] })
  clearable: boolean;
  @Prop({ default: null, type: [String] })
  label: string;
  @Prop({ default: null, type: [String] })
  placeholder: string;
  @Prop({ default: false, type: [Boolean] })
  disabled: string;
  @Prop({ default: null, type: [String] })
  noDataText: string | null;
  @Prop({ default: null, type: [String] })
  icon: string | null

  @Prop({ default: null, type: [Function] })
  onFetch: Function;
  @Prop({ default: '', type: [String] })
  defaultText: string;
  @Prop({ default: null, type: [Function] })
  onFetchRemote: Function;
  @Prop({ default: null, type: [String] })
  typeSearchEntity: string;
  /**
   *
   */
  constructor() {
    super();
    this.dtSearch = this.defaultText || '';
    this.dtIsLoading = false;
    this.dtOptions = this.items;
  }

  get vModel(): any[] | number | string {
    return this.value;
  }
  set vModel(value: any[] | number | string) {
    this.$emit('input', value)
  }

  get hasSlot() {
    return Object.keys(this.$slots).length > 0
      || Object.keys(this.$scopedSlots).length
  }

  get coItems(): any[] {
    return this.dtOptions;
  }

  mounted() {
    this.$watch('items', (value) => this.dtOptions = value)
    this.$watch('defaultText', (value) => this.dtSearch = value)
    this.$watch('dtSearch', this.handleSearchChange)
  }


  _clearTimeout: any;
  handleWrapData(data: { value: number, text: string }) {
    if (data) {
      this.dtOptions = this.dtOptions.concat(data)
    }
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.dtIsLoading = false;
    }, 300);
  }

  @Emit('change')
  handleChange(event) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      if (event) {
        (this.$refs['inputRef'] as any).blur()
      }
    }, 300);
  }

  @Emit('SearchChange')
  handleSearchChange(newValue, oldValue) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      if ((this.dtOptions.filter(x => (x[this.itemText] === newValue || x.text === newValue)).length > 0)
        /* || newValue === this.defaultText */) return;
      if (this.onFetchRemote && (!newValue || newValue.length >= 2)) {
        //this.dtIsLoading = true;
        //console.log('******************handleSearchChange')
        if(this.typeSearchEntity){
          this.onFetchRemote(newValue, this.handleWrapData, this.typeSearchEntity)
        } else {
          this.onFetchRemote(newValue, this.handleWrapData)
        }
      }
    }, this.debounce);

  }

  handleRemove(itemId: number | undefined) {
    if(itemId){
      if(!Array.isArray(this.vModel)){
        this.vModel= null
        this.$emit('change')
        return
      }

      if(this.returnObject) this.vModel= this.vModel.filter(item=> item.id !== itemId)
      else this.vModel= this.vModel.filter(item=> item !== itemId)
      this.$emit('change')
    }
  }
}

export default AutocompleteComponent;



// WEBPACK FOOTER //
// ./src/components/autocomplete/index.ts